import { render, staticRenderFns } from "./vehicleservicing.html?vue&type=template&id=83fd21b6&scoped=true&external"
import script from "./vehicleservicing.vue?vue&type=script&lang=js"
export * from "./vehicleservicing.vue?vue&type=script&lang=js"
import style0 from "./vehicleservicing.vue?vue&type=style&index=0&id=83fd21b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fd21b6",
  null
  
)

export default component.exports